module.exports = __webpack_public_path__ + "img/top_conbadge.ff2a38c9.jpg";